export default "__VITE_ASSET__BNcgRt6n__"